import Image from '../../Image/Image';

function ImageMessage({ url }: TMessageAtachment) {
  return <Image src={url} alt="" className="w-full max-w-md rounded-lg" />;
}

export default ImageMessage;
